import {dbConnect, openEndpointsDataStore} from 'dev/service-worker-interop/IndexedDBStore';

export default async function openEndpointsStore(): Promise<IDBObjectStore> {
  const db = await dbConnect(window);
  return openEndpointsDataStore(db);
}
